import type { HexMapState } from '../../engine/render/renderer';
import { getFreePopulation } from '../../engine/map/settlement';
import { hexDistance } from '../../engine/hex/hexMath';
import type { Cube } from '../../engine/hex/types';

export type FoundingStatus = {
    isControlled: boolean;
    hasExpedition: boolean;
    freePopulation: number;
    requiredPopulation: number;
    canFound: boolean;
};

export function getFoundingStatus(state: HexMapState, tileId: string): FoundingStatus {
    const isControlled = state.ownedTileIds.has(tileId);
    const requiredPopulation = state.config.initial.settlement.population;
    const freePopulation = Math.max(
        0,
        ...Object.values(state.settlementsById).map((entry) => getFreePopulation(entry)),
    );
    const hasExpedition = state.foundingExpeditions.some(
        (expedition) => expedition.targetTileId === tileId && expedition.status === 'traveling',
    );
    const canFound = freePopulation >= requiredPopulation && isControlled && !hasExpedition;

    return {
        isControlled,
        hasExpedition,
        freePopulation,
        requiredPopulation,
        canFound,
    };
}

export function getNearestSettlementId(state: HexMapState, target: Cube): string | null {
    const settlements = Object.values(state.settlementsById);
    if (settlements.length === 0) return null;
    let best = settlements[0];
    let bestDist = hexDistance(best.tilePosition, target);
    for (let i = 1; i < settlements.length; i += 1) {
        const settlement = settlements[i];
        const dist = hexDistance(settlement.tilePosition, target);
        if (dist < bestDist) {
            best = settlement;
            bestDist = dist;
        }
    }
    return best.id;
}
